module.exports = {"data":{"site":{"siteMetadata":{"title":"Moons of Saturn - Lost Coast Dev","description":"A Gatsby.js Starter based on Dimension by HTML5 UP"}}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = 92
// module chunks = 60335399758886 114276838955818